import { Typography } from '@material-ui/core';
import React from 'react';

import { CalendarModalTestID } from './CalendarModal.models';
import { useStyles } from './CalendarModal.styles';

interface Props {
  strongIntro?: string;
  normalText?: string;
}

export const CalendarModalInfo: React.FC<Props> = ({ strongIntro, normalText }) => {
  const { descriptionText } = useStyles();

  return (
    <Typography className={descriptionText} data-testid={CalendarModalTestID.ModalInfo}>
      {!!strongIntro ? <strong>{strongIntro}</strong> : ''}
      {!!strongIntro && !!normalText ? <span>&nbsp;</span> : ''}
      {normalText}
    </Typography>
  );
};
